/*eslint no-unused-vars: "off"*/

import {API_HOST} from "../Constants";
import parse from "url-parse";
import {parse as queryString, stringify as queryStringStringify} from "query-string";
import millify from "millify";
import {message} from "antd";


export const getLastDomByClassName = (className) => {
  if ( ! document ) return document;
  const domList = document.getElementsByClassName(className);
  return domList[domList.length-1];
};


export const rgbToArray = (rgb) => [
  parseInt(rgb.slice(1, 3), 16),
  parseInt(rgb.slice(3, 5), 16),
  parseInt(rgb.slice(5, 7), 16),
  parseInt(rgb.slice(7, 9), 16) || 255,
];


export const arrayToRgb = ([r, g, b, a]) => `rgba(${r}, ${g}, ${b}, ${a / 255})`;


export const rgbToCssRgbFunction = (rgb) => {
  const array = rgbToArray(rgb);
  return `rgba(${array[0]}, ${array[1]}, ${array[2]}, ${array[3] / 255})`;
};



export const zip = (a1, a2) => a1.map((x, i) => [x, a2[i]]);


export const getSplitList = (originList, chunkSizeList) =>
  chunkSizeList.map((size, idx) => {
    const idx0 = chunkSizeList.slice(0, idx).reduce((sum, x) => sum + x, 0);
    const idx1 = chunkSizeList.slice(0, idx + 1).reduce((sum, x) => sum + x, 0);
    return originList.slice(idx0, idx1);
  });


export const getRandom = (array) =>
  array[Math.floor(Math.random() * array.length)];


export const formatUid = (text) => {
  // 2자리-4자리-2자리-7자리
  // 92로 시작된 허가번호 뒤 7자리 X 처리
  if (typeof text === "string" && text.length === 15 && text.slice(0, 2) === "92") {
    return [text.slice(0, 2), text.slice(2, 6), text.slice(6, 8), "XXXXXXX"].join("-");
  }
  if (typeof text === "string" && text.length === 15) {
    return [text.slice(0, 2), text.slice(2, 6), text.slice(6, 8), text.slice(8)].join("-");
  }
  return text;
};

export const formatServiceCode = (rds_svc_form_cd) => {
  if(rds_svc_form_cd === '05') return '2G';
  if(rds_svc_form_cd === '06') return '2G';
  if(rds_svc_form_cd === '15') return '3G';
  if(rds_svc_form_cd === '18') return '4G';
  if(rds_svc_form_cd === '19') return '4G';
  if(rds_svc_form_cd === '43') return '5G';
  if(rds_svc_form_cd === '45') return '5G';
  return rds_svc_form_cd;
}

export const degressToPosition = (deg) => {
  let d = parseInt(deg);
  const minfloat = Math.abs((deg-d) * 60);
  let m = Math.floor(minfloat);
  const secfloat = (minfloat-m)*60;
  let s = Math.round(secfloat);
  d = Math.abs(d);

  if (s===60) {
   m++;
   s=0;
  }
  if (m===60) {
   d++;
   m=0;
  }
  return d + "° " + m + "' " + secfloat.toFixed(2) + "\"";
}


export const positionToDegress = (position) => {
  if ( typeof position !== 'string' )
    return position;

  // "37° 29' 49.71" to 37.496944444444445
  const [d, m=0, s=0] = position.match(/(\d+\.?\d+)/g).map(v => parseInt(v));
  return d + m/60 + s/3600;
};


export const downloadExcel = (response, excelFileName) => {
  const {data} = response;
  // 스프링에서 설정한 filename을 가져옵니다.
  const contentDisposition = response.headers['content-disposition'];
  let fileName = 'unknown';
  if (contentDisposition) {
    const fileNameMatch = contentDisposition.match(/filename="(.+)"/);
    if (fileNameMatch.length === 2) fileName = decodeURIComponent(fileNameMatch[1]);
  }
  excelFileName = fileName;
  if (window.navigator && window.navigator.msSaveOrOpenBlob) { // for IE
     window.navigator.msSaveOrOpenBlob(data, excelFileName);
  } else {
    const url = window.URL.createObjectURL(new Blob([data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', excelFileName);
    document.body.appendChild(link);
    link.click()
  };
};

/*
 as-is의 excel다운로드 이용시 파일 이름앞 utf-8 문자열을 제거합니다.
 */
export const downloadExcelASIS = (response, excelFileName) => {
  const {data} = response;
  // 스프링에서 설정한 filename을 가져옵니다.
  const contentDisposition = response.headers['content-disposition'];

  if (contentDisposition) {
    let fileName = 'unknown';
    const startIndex = contentDisposition.indexOf("utf-8") + "attachment; filename=\"".length + 1;
    const endIndex = contentDisposition.length - 1;
    fileName = decodeURIComponent(contentDisposition.substring(startIndex, endIndex));
    excelFileName = fileName;
  }

  if(navigator.appVersion.toString().indexOf('.NET') > 0){ // 익스플로러면..
    const blob = new Blob([data]);
    window.navigator.msSaveOrOpenBlob(blob, excelFileName);

  } else {
    const url = window.URL.createObjectURL(new Blob([data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', excelFileName);
    document.body.appendChild(link);
    link.click();
  }

};


export const shuffle = (a) => {
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
};


export const numberWithCommas = (number) => {
  if(number){
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  } else {
    return number;
  }
};


export const sum = (numberArray) => {
  return numberArray.reduce((x, y) => x + y, 0);
};


export const makeQueryString = (objects) => {
  return Object.keys(objects).reduce((a, k) => {
    a.push(k + '=' + encodeURIComponent(objects[k]));
    return a
  }, []).join('&');
};


export const chunksForArray = (array, chunk_size) => {
  const chunks = [];
  for (let i=0; i<array.length; i+=chunk_size) {
    chunks.push(array.slice(i, i+chunk_size));
  }
  return chunks;
};


export const arrayToObject = (array) => {
  return Object.entries(array).reduce((acc, [index, title]) => { acc[index] = title; return acc; }, {});
};


export const getApiUrl = (extraGetParams) => {
  let currentUrl;
  if (window.CURRENT_URL) {
    currentUrl = window.CURRENT_URL;
  } else {
    currentUrl = API_HOST + window.location.pathname + window.location.search;
  }
  if (currentUrl.indexOf('?') === -1) {
    currentUrl += '?';
  }

  const parsed = parse(currentUrl.replace('.do?', '.json?'));
  const query = {...queryString(parsed.query), ...extraGetParams};

  return `${parsed.origin}${parsed.pathname}?${queryStringStringify(query)}`;
};


export const getApiHost = () => {
  if ( window.CURRENT_URL ) {
    return parse(window.CURRENT_URL).origin;
  }
  else {
    return API_HOST;
  }
};


export function difference(setA, setB) {
    const setDiff = new Set(setA);
    for (let elem of setB) {
        setDiff.delete(elem);
    }
    return setDiff;
}


export const getReadableFreq = (value) => {
  if ( value ) {
    return millify(value, {
      units: ["Hz", "kHz", "MHz", "GHz"],
      space: true,
    });
  }
};

export const getReadableFreqNoUnit = (value) => {
  if ( value ) {
    return millify(value, {
      units: ["", "", "", ""],
      space: true,
    });
  }
};

// 현재기준으로 작년을 가져옵니다.
export const getLastYear = () => {
  const today = new Date();
  const weekOfMonth = getWeekOfMonth(today);
  if(weekOfMonth < 2) { // 1주차는
    return new Date().getFullYear()-2; // 재작년
  } else { // 2주차 이후부터
    return new Date().getFullYear()-1; // 작년
  }
}

// 주차 계산
export const getWeekOfMonth = (date) => {
  const tdt = new Date(date.valueOf());
  const dayn = (date.getDay() + 6) % 7;
  tdt.setDate(tdt.getDate() - dayn + 3 );
  const firstThursday = tdt.valueOf();
  tdt.setMonth(0, 1);

  if (tdt.getDay() !== 4) {
    tdt.setMonth(0, 1 + ((4 - tdt.getDay()) + 7) % 7);
  }
  return 1 + Math.ceil((firstThursday - tdt) / 604800000);
}

// 1950~작년까지의 배열을 생성합니다.
export const OPTION_YEAR = () => {
  const oldestYear = 1950; // as-is의 데이터 조회 마지막 연도
  let arrYear = [];

  for (let year = getLastYear(); year >= oldestYear; year--) {
    arrYear.push({
        value : year.toString()
    });
  }
  return arrYear;
};

// 1988~작년까지의 배열을 생성합니다.
export const OPTION_YEAR_SINCE_1988 = () => {
  const oldestYear = 1988; // as-is의 데이터 조회 마지막 연도
  let arrYear = [];

  for (let year = getLastYear(); year >= oldestYear; year--) {
    arrYear.push({
        value : year.toString()
    });
  }
  return arrYear;
};

// 1~12월 선택 배열 생성
export  const OPTION_MONTH = () => {
  let arrMonth = [];
  for ( let month = 1; month <= 12; month++){
    arrMonth.push({
      value : month.toString()
    })
  }
  return arrMonth;
};

// 목록보기 컬럼 정렬하기
export function makeTableSorterFn(fieldName) {
  return (row1, row2) => {
    const prop1 = row1[fieldName];
    const prop2 = row2[fieldName];

    if(prop1 && prop2) {
      if (typeof prop1 === "number"){
        return prop1 - prop2;
      }
      return [...prop1].map(ch => ch.charCodeAt(0)) > [...prop2].map(ch => ch.charCodeAt(0)) ? 1 : -1;
    }
  };
}

export function makeTableSorterFnNumber(fieldName) {
  return (row1, row2) => {
    const prop1 = Number.isNaN(Number(row1[fieldName])) ? 0 : Number(row1[fieldName]);
    const prop2 = Number.isNaN(Number(row2[fieldName])) ? 0 : Number(row2[fieldName]);

    return prop1 - prop2;
  };
}

export function stringToIntArray(s) {
  if ( typeof s !== 'string' ) return s;
  return [...s].map(ch => ch.charCodeAt(0));
}

export function getGrad(maxVal, nowVal) {
  if ( maxVal === 0 ) return 0;
  if ( !maxVal || !nowVal ) return 99;
  return Math.floor(Number(nowVal) / (Number(maxVal) / 10));
}

export function msgClose() {
  setTimeout(() => {
    message.destroy();
  }, 2000);
};